import {keyIn} from '../../utils'

const baseFilterAvailParams = (extend=[]) => (params) => {
    return params.filter(keyIn(
      'hotels',
      'hotelId',
      'language',
      'date',
      'stay_length',
      'channel',
      'country',
      'source',
      'occups',
      'refundability',
      'promotion_code',
      'gift_voucher',
      'company_id',
      'referer_code',
      'avail_code',
      'tdckehc',
      'daily_details',
      'checkin_days',
      ...extend
      )
  );
};

export const filterAvailParams  = baseFilterAvailParams();

export const filterAvailLoyaltyParams = baseFilterAvailParams(["loyalty"]);

export const filterAvailCalendarParams = params =>
  params.filter(
    keyIn(
      'hotels',
      'hotelId',
      'language',
      'channel',
      'country',
      'source',
      'occups',
      'refundability',
      'promotion_code',
      'gift_voucher',
      'company_id',
      'referer_code',
      'avail_code',
      'tdckehc',
      'daily_details',
      'skip_restrictions',
      'loyalty',
      'checkin_days',
      "loyalty"
    )
  );


export const filterAvailCacheParams = params =>
  params.filter(
    keyIn(
      'hotelId',
      'language',
      'channel',
      'country_id',
      'city_id',
      'source',
      'occups',
      'referer_code',
      'tdckehc'
    )
  );

// Parametros de la URL que se guardan como cookies
export const allowedCookieParams = ["avail_code", "promotion_code", "referer_code"];

export const addParamToURL = (param, value) => {
  let searchParams = new URLSearchParams(window.location.search);
  const history = window.history;
  if(searchParams.has(param)){
    searchParams.delete(param);
  }

  searchParams.append(param, value);
  if (history.replaceState) {
      let searchString = decodeURIComponent(searchParams.toString().length > 0 ? '?' + searchParams.toString() : '');
      let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname +  searchString + window.location.hash;
      history.replaceState(null, '', newUrl);
  }
};

export const removeParamFromURL = (param) => {
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  const history = window.history;
  if (history.replaceState) {
      let searchString = decodeURIComponent(searchParams.toString().length > 0 ? '?' + searchParams.toString() : '');
      let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname +  searchString + window.location.hash;
      history.replaceState(null, '', newUrl);
  }
};


